
import breakpoints from './utils/breakpoints'
import Animations from './components/Animations/Animations'
import IframeYoutube from './components/IframeYoutube/IframeYoutube'
import IframeVimeo from './components/IframeVimeo/IframeVimeo'
import ToggleElement from './utils/ToggleElement'
import initMenuMobile from './components/Menu/MenuMobile'
import initMegaMenu from './components/Menu/MegaMenu'
import { HeaderScroll } from './components/HeaderScroll/HeaderScroll';
import UploadHelper from './components/UploadHelper/UploadHelper'
import LangChooser from './components/LangChooser/LangChooser'

customElements.define('iframe-youtube', IframeYoutube)
customElements.define('iframe-vimeo', IframeVimeo)

const ToggleTriggers = [...document.querySelectorAll('[data-toggle-trigger]')]
for (let trigger of ToggleTriggers) {
  new ToggleElement(trigger)
}


if (document.getElementById('header')) {
  initMenuMobile({ menuBreakpoint: breakpoints.menu })
  initMegaMenu({ largeWidth: breakpoints.menu })
  HeaderScroll()
}

new LangChooser('lang-chooser')

const uploadHelperElements = [...document.querySelectorAll('[data-upload-helper]')];
for (let uploadHelperElement of uploadHelperElements) {
  new UploadHelper(uploadHelperElement)
}

const teasers = [...document.querySelectorAll('.teaser')]
for (let teaser of teasers) {
   teaser.addEventListener('mouseover', () => {
    teaser.parentNode.classList.add('card-teasers__grid--hover')
  })

  teaser.addEventListener('mouseout', () => {
    teaser.parentNode.classList.remove('card-teasers__grid--hover')
  })
}

import ModalStorage from './components/ModalStorage/ModalStorage';

new Animations()

document.addEventListener('htmx:afterSwap', (evt) => {
  if (evt.target.id.startsWith('modal-')) {
    const modal = document.querySelector('.modal--onload');
    if (modal) {
      new ModalStorage(modal)
    }
  }
});